import { render, staticRenderFns } from "./NotePresetField.vue?vue&type=template&id=4a241c36&scoped=true"
import script from "./NotePresetField.vue?vue&type=script&lang=js"
export * from "./NotePresetField.vue?vue&type=script&lang=js"
import style0 from "./NotePresetField.vue?vue&type=style&index=0&id=4a241c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a241c36",
  null
  
)

export default component.exports